import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=5f631a6a&"
import script from "./ChatSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports